// ==================================BUY NOW BUTTON ON PRODUCT CARD===================================================
      $('body').on('click','.dd',function(){
      
        $(this).parent().find('.shopify-payment-button__button').click();
         console.log("BUY NOW BUTTON= " + $(this).parent().find('.shopify-payment-button__button').text());
          return false;
      });
      
// ===================================hover on menu============================================

      $(function() {
  $('.firstlavel4').on('mouseenter',function() {
    $(this).attr('open', '');
  })
   $('.firstlavel4').on('mouseleave',function() {      
    $(this).removeAttr("open","open");
  })
});



// ===================LOAD MORE CODE===============================================
 
$(document).ready(function(){
  
  // ===================SOLD OUT BUTTON PDP================================================================
  
  var pdp_button=$('.product-form__submit.product-form__submit_custom').text();
    if(pdp_button.includes('Sold out')){
      $('.product-form__submit.product-form__submit_custom').attr('type','button');
    }

  
  
   var pagesss = 1;
$('.js-load-more').on('click', function(){
  var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
  $this.attr('disabled', true);
  $this.find('[load-more-text]').addClass('hide');
  $this.find('[loader]').removeClass('hide');
  
   pagesss = pagesss+1;
 
  var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+pagesss);
  $('[data-current-page]').val(currentPage);
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.grid--view-items').append($(responseHTML).find('.grid--view-items').html());
      //on load more change ratings style
$('.card-wrapper').each(function(e){
              var zz = $(this).children().find('.card-information .jdgm-widget').children().data('averageRating');
        	zz = parseFloat(zz).toFixed(2);
         if(zz != 0.00){
        $(this).children().find('.CustomratingDiv .rating').html(zz);
 		} else {
          $(this).children().find('.CustomratingDiv .jdgm-star').removeClass('jdgm-star');
        }
            });
    },
    complete: function() {
      
       if(pagesss==totalPages){
            $('.load-more_wrap').css('display','none');
            console.log('total');
          }

      
      if(pagesss <= totalPages) {
            $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
          } 
      
    }
  })
  
  
//   var productCount1 = $(this).attr("data-pdcount");
//   var productCount = parseInt(productCount1);
//   loadmore_hide(productCount);
  
  
});
 $('#judgeme_product_reviews').removeAttr('style');
});



function loadmore_hide(productCount){
   var li_grid_count1 = $("#main-collection-product-grid li").length;
   var li_grid_count = parseInt(li_grid_count1);
   if(li_grid_count >= productCount){
     $('button.js-load-more span:last-child').hide();
   }
 } 
  var productCount1 = $("button.js-load-more").attr("data-pdcount");
  var productCount = parseInt(productCount1);
  loadmore_hide(productCount);
// ==================================================================================
// $(document).ready(function(){
 
// });

